import { useGetProductRelationShips } from './useGetProductRelationShips';
export const useHasBillingManagementActive = () => {
    const { getBillingProduct } = useGetProductRelationShips();
    const billingProduct = getBillingProduct();
    return {
        hasBillingActive: billingProduct?.status === 'ACTIVATED',
        isLoading: false,
    };
};
